import React, { useRef, useState } from 'react';
import { message } from 'antd';
import { theme } from 'utils/style/theme';
import DefaultButton from 'components/button/DefaultButton';
import DefaultInput from 'components/input/DefaultInput';
import DefaultModal from 'components/modal/DefaultModal';
import DefaultForm from 'components/form/DefaultForm';
import { IBubbleSet, ICommonCode } from 'utils/types/storyTypes';
import { Select } from 'antd';
import styled from 'styled-components';
import { storyApi } from 'apis/story/storyApis';
import { useTranslation } from 'react-i18next';
import PrimaryButton from 'components/button/PrimaryButton';
import SelectBox from 'components/SelectBox';
import InputStyled from 'components/InputStyled';

/**
 * * 작품 관리 - 작품 등록 모달
 */

interface IProjectProp {
  title: string;
  project_type: number;
}
interface IProps {
  visible: boolean;
  setVisible: (e: any) => void;
  langList: ICommonCode[] | null;
  setTotalList: React.Dispatch<any>;
}
const ProjectRegisterModal = ({
  visible,
  setVisible,
  langList, // 언어 dropdown 용도
  setTotalList,
}: IProps) => {
  const { t } = useTranslation();
  const [inputData, setInputData] = useState<IProjectProp | null>();
  const [defaultLang, setDefaultLang] = useState<string>('KO');
  const inputRef = useRef<HTMLInputElement[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setInputData({ ...inputData!, [name]: value });
  };

  const handleSubmit = async () => {
    // ! 유효성. hooks로 뺄 수 없나?(22.10.05. sjy)

    if (inputData?.title === undefined) {
      inputRef?.current[1]?.focus();
      message.error(
        t('story.modal.projectRegistration.emptyProjectTitleMessage'),
        1,
      );
      return;
    }
    try {
      setLoading(true);
      const res = await storyApi.createSoty({
        project_type: 'Otome',
        default_lang: defaultLang,
        title: inputData.title,
      });
      message.success(t('story.modal.projectRegistration.successMessage'), 1);
      setInputData(null);
      setTotalList(res.projects);
      setLoading(false);
      handleClose();
    } catch (err) {
      message.success(err?.mesage, 1);
      setLoading(false);
    }
  };

  const handleClose = () => {
    setVisible(false);
    setInputData(null);
  };

  const handleChangeLang = (value) => {
    setDefaultLang(value);
  };

  return (
    <DefaultModal
      title={t('story.modal.projectRegistration.title')}
      visible={visible}
      onCancel={handleClose}
      footer={
        <ButtonWrapper>
          <PrimaryButton
            text={t('story.modal.projectRegistration.submit')}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
            loading={loading}
          />
        </ButtonWrapper>
      }
    >
      <DefaultForm>
        <Wrapper>
          <LangSelectWrapper>
            <p>{t('story.modal.projectRegistration.projectTitle')}: </p>
            <InputStyled
              name='title'
              value={inputData?.title}
              onChange={handleInputChange}
              ref={(el: HTMLInputElement) => (inputRef.current[1] = el)}
              // ref={inputRef}
            />
          </LangSelectWrapper>
          <LangSelectWrapper>
            <p>{t('story.modal.projectRegistration.defaultLang')}: </p>
            <SelectBox
              defaultValue={'KO'}
              onChange={(value) => handleChangeLang(value)}
              options={langList?.map((v, i) => {
                return {
                  key: v.code,
                  value: v.code,
                  label: v.code_name,
                };
              })}
            />
            <p className='tips'>
              ** 베타버전에서 작품 등록시 권한이 생성 계정에 귀속됩니다. 타인과
              프로젝트를 공유하기 위해서는 관리자에게 문의주세요
            </p>
          </LangSelectWrapper>
        </Wrapper>
      </DefaultForm>
    </DefaultModal>
  );
};

export default ProjectRegisterModal;

const Wrapper = styled.div`
  & > * + * {
    margin-top: 1rem;
  }
`;

const LangSelectWrapper = styled.div`
  margin-bottom: 1rem;
  & > * + * {
    margin-top: 8px;
  }
  p {
    color: ${theme.colors.dark_500};
    font-size: ${theme.fontSizes.sm};
    font-weight: ${theme.fontWeights.normal};
  }
  .tips {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.red_300};
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;
